import api from '@/api'
import store from '@/store/store'
import util from '@/common/util'

const app = {
  state: {
    device: 'desktop',
    sidebar: {
      opened: store.getSidebarStatus() === 'open',
      withoutAnimation: false
    },
    games: [],
    dataPickerValue: util.getDateRangeValue(-6),
    appId: store.getAppId(),
    products: [],
    channels: [],
    channelId: 0,
    channelCascadeOptions: [],
    channelCascadeIds: [[0]],
    servers: [],
    serverList: [],
    serverId: 0,
    routerPrivilege: new Map()
  },
  mutations: {
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    TOGGLE_SIDEBAR: state => {
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
      if (state.sidebar.opened) {
        store.setSidebarStatus('open')
      } else {
        store.setSidebarStatus('close')
      }
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      store.setSidebarStatus('close')
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    SET_GAMES: (state, games) => {
      state.games = games
    },
    SET_APP_ID: (state, appId) => {
      state.appId = appId
    },
    SET_DATA_PICKER_VALUE: (state, dataPickerValue) => {
      state.dataPickerValue = dataPickerValue
    },
    SET_PRODUCTS: (state, products) => {
      state.products = products
    },
    SET_CHANNELS: (state, channels) => {
      state.channels = channels
    },
    SET_CHANNEL_CASCADE_OPTIONS: (state, channelCascadeOptions) => {
      state.channelCascadeOptions = channelCascadeOptions
      state.channelCascadeIds = [[0]]
    },
    SET_CHANNEL_CASCADE_IDS: (state, channelCascadeIds) => {
      state.channelCascadeIds = channelCascadeIds
    },
    SET_CHANNEL_ID: (state, channelId) => {
      state.channelId = channelId
    },
    SET_SERVERS: (state, servers) => {
      state.servers = servers
      state.serverId = 0
    },
    SET_SERVER_ID: (state, serverId) => {
      state.serverId = serverId
    },
    SET_SERVER_LIST: (state, serverList) => {
      state.serverList = serverList
    },
    SET_ROUTER_PRIVILEGE: (state, routerPrivilege) => {
      state.routerPrivilege = routerPrivilege
    }
  },
  actions: {
    ToggleDevice: ({ commit }, device) => {
      commit('TOGGLE_DEVICE', device)
    },
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar: ({ commit }, { withoutAnimation }) => {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    GetGames ({ commit, state }) {
      return new Promise((resolve, reject) => {
        api.gameList().then(res => {
          let games = []
          for (let d of res) {
            games.push({ value: d.id, label: d.id + '-' + d.name })
          }
          commit('SET_GAMES', games)
          if (games.length > 0) {
            let appId = store.getAppId()
            if (!appId) {
              appId = games[games.length - 1].value
            }
            appId = parseInt(appId)
            commit('SET_APP_ID', appId)
            store.setAppId(appId)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    ChangeGame ({ commit, state }, appId) {
      return new Promise((resolve, reject) => {
        // 渠道列表
        api.channelList(appId).then(res => {
          let zero = { value: 0, label: '0-全部' }
          let channels = [zero]
          let options = [zero]
          for (let p of res) {
            let obj = { value: p.id, label: p.id + '-' + p.name, children: [] }
            if (p.channels.length !== 0) {
              for (let c of p.channels) {
                let item = { value: c.id, label: c.id + '-' + c.name }
                obj.children.push(item)
                channels.push(item)
              }
            }
            options.push(obj)
          }
          commit('SET_APP_ID', appId)
          commit('SET_CHANNELS', channels)
          commit('SET_CHANNEL_CASCADE_OPTIONS', options)
          store.setAppId(appId)
        })
        api.serverList(appId).then(res => {
          let servers = [{ value: 0, label: '0-全部' }]
          if (res) {
            for (let d of res.data) {
              servers.push({ value: d.id, label: d.id + '-' + d.name })
            }
          }
          commit('SET_SERVERS', servers)
        })
        // 商品列表
        api.gameProducts(appId).then(res => {
          let products = []
          if (res) {
            for (let p of res) {
              products.push({ value: p.id, label: p.name, price: p.price })
            }
          }
          commit('SET_PRODUCTS', products)
        })
        // api.getChannelList(appId).then(res => {
        //   console.log(res)
        //   let channels = { 0: '0-全部' }
        //   for (let c of res) {
        //     channels[c.channelId] = c.channelId + '-' + c.channelName
        //   }
        //   commit('SET_APP_ID', appId)
        //   commit('SET_CHANNELS', channels)
        //   store.setAppId(appId)
        //   // api.getChannelGroup(appId).then(res => {
        //   //   console.log(res)
        //   // })
        // })
        // api.serverList(appId).then(res => {
        //   let servers = [{ value: 0, label: '0-全部' }]
        //   for (let d of res.data) {
        //     servers.push({ value: d.id, label: d.id + '-' + d.name })
        //   }
        //   commit('SET_SERVERS', servers)
        // })
        resolve()
      })
    },
    ChangeChannelId ({ commit, state }, channelId) {
      return new Promise((resolve, reject) => {
        commit('SET_CHANNEL_ID', channelId)
        resolve()
      })
    },
    // 服务器ID
    ChangeServerId ({ commit, state }, serverId) {
      return new Promise((resolve, reject) => {
        commit('SET_SERVER_ID', serverId)
        resolve()
      })
    },
    // 服务器ID列表(分服日报月报)
    ChangeServerList ({ commit, state }, serverList) {
      return new Promise((resolve, reject) => {
        commit('SET_SERVER_LIST', serverList)
        resolve()
      })
    },
    ChangeDataPickerValue ({ commit, state }, dataPickerValue) {
      return new Promise((resolve, reject) => {
        commit('SET_DATA_PICKER_VALUE', dataPickerValue)
        resolve()
      })
    },
    ChangeChannelCascadeIds ({ commit, state }, channelCascadeIds) {
      return new Promise((resolve, reject) => {
        commit('SET_CHANNEL_CASCADE_IDS', channelCascadeIds)
        resolve()
      })
    },
    DisposeRouterPrivilege ({ commit, state }, routerPrivilege) {
      return new Promise((resolve, reject) => {
        commit('SET_ROUTER_PRIVILEGE', routerPrivilege)
        resolve()
      })
    }
  }
}

export default app
